import { useEffect, useState } from "react";
import { useCurrentUser, useCentralApi } from "hooks/shared";
import { IWorkItemWorkflowsResult }  from "models/work-items/IWorkItemWorkflow";

const GetWorkItemsResult: IWorkItemWorkflowsResult = {
    workflows: [],
    hasAccessToCreateWorkflow: false,
    hasAccessToEditWorkflow: false,
    total:0
}

type WorkItemWorkflowsResult = [
    IWorkItemWorkflowsResult,
    number,
    boolean,
    string | null,
    () => void
];

type UseWorkItemWorkflowsSignature = 
(
    workitemId: number
)  => WorkItemWorkflowsResult;

const useWorkItemWorkflows: UseWorkItemWorkflowsSignature = (workitemId) => {
    
    const [ _lastQuery, _setLastQuery ] = useState<string>('');
    const [result, setResult] = useState<IWorkItemWorkflowsResult>(GetWorkItemsResult);
    const [ total, setTotal ] = useState<number>(0);
    const [ error, setError ] = useState<string | null>(null);
    const [ loading, setLoading ] = useState<boolean>(true);
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

    
        const controller = new AbortController();
        const fetchWorkItems = async () => {
            if (user && user.id_token) {
                setLoading(true);
                
                try {
                    const resp = await fetcher(`/api/v3/workitems/${workitemId}/workflows`, {
                        signal: controller.signal
                    });
                    
                    if (!resp.ok) {
                        // RESPOND TO ERRORS
                    }

                    const data = await resp.json() as IWorkItemWorkflowsResult;
                    setResult(data);
                    
                    if (data.total !== total) {
                        setTotal(data.total);
                    }                    
                } catch (err) {
                    console.log(err);
                    
                } finally {
                    if (!controller.signal.aborted)
                        setLoading(false);
                }
            }
        };

    useEffect(() => {  
        fetchWorkItems();
        return () => {
            controller.abort();
            setLoading(false);
        }
    }, [ user, workitemId ]);

    return [
        result,
        total,
        loading,
        error,
        fetchWorkItems
    ];
};

export default useWorkItemWorkflows;